import { apiClient } from '../_helpers';;

export const reportingService = {
  getUserHistory
};

async function getUserHistory(params) {
    try {
    	var ps = "";
	    var ccat = "";
	    if( params && params.userId )
	    {
	    	ps = ps + "userId=" + params.userId;
	    	ccat = "&";
	    }
	    if( params && params.query)
	    {
	      ps = ps + "searchQuery=" + params.query;
	      ccat = "&";
	    }
	    if( params && params.pageSize )
	    { 
	      ps = ps + ccat + "pageSize=" + params.pageSize;
	      ccat = "&";
	    }
	    if( params && params.page )
	    {
	      ps = ps + ccat + "pageNumber=" + params.page;
	      ccat = "&";
	    }

      	const response = await apiClient(`users/${params.userId}/history?${ps}`)
          .get();
          return response.data;
    } catch (error) {
        return error;
    }
}